import React from "react";
import axios from "axios";
import FQDropdownBox from "../../../components/FQDropdownBox/FQDropdownBox";
import CoordinatorsDropdown from "../../../components/CoordinatorsDropdown/CoordinatorsDropdown";
import ErrorBoundary from "../../../components/ErrorBoundary/ErrorBoundary";
import {
  rebuildExperienceFQObject,
  rebuildTalentsFQObject,
  rebuildLicensesFQObject,
  rebuildAcademicDegreeFQObject,
  rebuildCertificateFQObject,
  rebuildLanguagesFQObject,
  rebuildDynamicsFQObject,
} from "./FilterQuestions/RebuildFilterQuestions/RebuildFilterQuestions";
import { grey } from "@material-ui/core/colors";
import {
  Typography,
  Grid,
  Paper,
  TextField,
  InputLabel,
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Switch,
  Button,
  Icon,
  MenuItem,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
  Box,
  Checkbox,
} from "@material-ui/core";
import SaveRoundedIcon from "@material-ui/icons/SaveRounded";
import NavigateBeforeRoundedIcon from "@material-ui/icons/NavigateBeforeRounded";
import NavigateNextRoundedIcon from "@material-ui/icons/NavigateNextRounded";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import LocationCityRoundedIcon from "@material-ui/icons/LocationCityRounded";
import AxiosErrorHandling from "../../../components/AxiosErrorHandling/AxiosErrorHandling";
import ConfigurationListsContext from "../../../context/configurationListsContext";
import CustomIcon from "../../../components/NumberCircleIcon/NumberCircleIcon";
import { withRouter } from "react-router-dom";
import {
  AI_EXPERIENCES,
  AI_SKILLS,
  AI_ACADEMIC_DGREE,
  AI_CERTIFICATES,
  AI_DYNAMICS,
  AI_LANGUAGES,
  AI_LICENSES,
  MAX_HOURLY_RATE,
} from "../../../config/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      marginTop: theme.spacing(2),
    },
    "& .MuiFormControl-fullWidth": {
      marginTop: theme.spacing(2),
    },
    "& .MuiButton-endIcon": {
      display: "inherit",
      marginLeft: 8,
      marginRight: -4,
    },
  },
  gridSpace: {
    "& .MuiGrid-item": {
      marginBottom: theme.spacing(2),
    },
  },
  collapse: {
    "& .MuiCollapse-wrapperInner": {
      display: "flex",
      alignItems: "center",
    },
  },
  textField: {
    "& .MuiSvgIcon-root": {
      color: grey[500],
    },
  },
  addJobProgressMenu: {
    "& > *": {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  paper: {
    padding: theme.spacing(3),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
  },
  cancel: {
    marginLeft: theme.spacing(1),
  },
  ButtonRight: {
    justifyContent: "flex-start",
  },
}));

const targetMenuItems = () => {
  let tmi = [];
  for (let i = 0; i < 30; i++) {
    tmi = [
      ...tmi,
      <MenuItem key={(i + 1).toString()} value={i + 1}>
        {(i + 1).toString()}
      </MenuItem>,
    ];
  }
  return tmi;
};

const AddNewJob = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [wizardStep, setWizardStep] = React.useState(1);
  const [selectedCompany, setSelectedCompany] = React.useState({});
  const [ownerId, setOwnerId] = React.useState(0);
  const [selectedJobExtent, setSelectedJobExtent] = React.useState("");
  const [jobTitle, setJobTitle] = React.useState("");
  const [selectedArea, setSelectedArea] = React.useState([]);
  const [selectedProfessions, setSelectedProfessions] = React.useState([]);
  const [salaryMinimum, setSalaryMinimum] = React.useState(0);
  const [salaryMaximum, setSalaryMaximum] = React.useState(2000);
  const [discreteSalary, setDiscreteSalary] = React.useState(true);
  const [discreteCompany, setDiscreteCompany] = React.useState(true);
  const [jobReqs, setJobsReqs] = React.useState("");
  const [jobDescription, setJobDescription] = React.useState("");
  const [openSalaryQuestion, setOpenSalaryQuestion] = React.useState(false);
  const [openSalaryValueBy, setOpenSalaryValueBy] = React.useState("month");
  const [jobCity, setJobCity] = React.useState("");
  const [jobRecruitmentTarget, setJobRecruitmentTarget] = React.useState(1);
  const [jobId, setJobId] = React.useState(-1); //always -1 in add mode, or job id in edit mode
  const [jobExternalId, setJobExternalId] = React.useState("");
  const [coordinatorName, setCoordinatorName] = React.useState("");
  const [employmentType, setEmploymentType] = React.useState("recruitment"); //the other option is employment
  const [isEditMode, setIsEditMode] = React.useState(false); //if this is true, we are in job edit mode
  const [isPublished, setIsPublished] = React.useState(false); //true publish date is not null
  const [autoDistribution, setAutoDistribution] = React.useState(false); //If true, after import users will be published.
  const [error, setError] = React.useState(null);
  const [
    experienceFilterQuestions,
    setExperienceFilterQuestions,
  ] = React.useState([]);
  const [talentsFilterQuestions, setTalentsFilterQuestions] = React.useState(
    []
  );
  const [licensesFilterQuestions, setLicensesFilterQuestions] = React.useState(
    []
  );
  const [
    languagesFilterQuestions,
    setLanguagesFilterQuestions,
  ] = React.useState([]);
  const [dynamicFilterQuestions, setDynamicsFilterQuestions] = React.useState(
    []
  );
  const [
    academicDegreeFilterQuestions,
    setAcademicDegreeFilterQuestions,
  ] = React.useState([]);
  const [
    certificateFilterQuestions,
    setCertificateFilterQuestions,
  ] = React.useState([]);

  const handleMinimumSalaryChange = (event) => {
    setSalaryMinimum(parseInt(event.target.value));
    parseInt(event.target.value) > MAX_HOURLY_RATE
      ? setOpenSalaryValueBy("month")
      : setOpenSalaryValueBy("hour");
  };
  const handleMaximumSalaryChange = (event) => {
    setSalaryMaximum(parseInt(event.target.value));
  };
  const handleJobsReqsChange = (event) => {
    setJobsReqs(event.target.value);
  };
  const handleJobsDescriptionChange = (event) => {
    setJobDescription(event.target.value);
  };

  const handleOpenSalaryValueChange = (event) => {
    setOpenSalaryValueBy(event.target.value);
  };

  const postNewJob = async () => {
    const jobData = {
      title: jobTitle,
      "jobs-sectors": selectedProfessions.map((prof) => prof.id).join(", "),
      author: ownerId ? ownerId : localStorage.getItem("userId"),
      fields: {
        job_extent: selectedJobExtent.id,
        company_id: selectedCompany.id,
        job_area: selectedArea.value,
        minimum_salary: salaryMinimum,
        maximum_salary: salaryMaximum,
        discrete_company: discreteCompany,
        discrete_salary: discreteSalary,
        job_city: jobCity,
        external_id: jobExternalId,
        employment_type: employmentType,
        job_requirements: jobReqs,
        job_recruitment_target: jobRecruitmentTarget,
        open_salary_question: openSalaryQuestion,
        open_salary_value_by: openSalaryValueBy,
        coordinator_name: coordinatorName,
        job_time_limit: 72,
        job_status: "active",
        auto_distribution: autoDistribution,
      },
      content: jobDescription,
      status: "publish",
    };
    //special case where I need to add Authrorization because this is being used by candidates as well
    axios.defaults.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "token"
    )}`;
    let newJobId = -1;
    axios
      .post("/wp-json/wp/v2/jobs", jobData)
      .then((jobRes) => {
        newJobId = parseInt(jobRes.data.id);
        axios.post("/wp-json/api/v2/updateJobFilterQuestions", {
          jobId: parseInt(jobRes.data.id),
          experience: { experienceFilterQuestions },
          talents: { talentsFilterQuestions },
          licenses: { licensesFilterQuestions },
          academicDegree: { academicDegreeFilterQuestions },
          certificate: { certificateFilterQuestions },
          languages: { languagesFilterQuestions },
          dynamics: { dynamicFilterQuestions },
        });
      })
      .then((fqRes) => {
        props.addedSuccessfully(newJobId);
      })
      .catch((err) => {
        setError(err);
      });
  };

  const updateJob = async () => {
    const jobData = {
      title: jobTitle,
      author: ownerId ? ownerId : localStorage.getItem("userId"),
      "jobs-sectors": selectedProfessions.map((prof) => prof.id).join(", "),
      fields: {
        job_extent: selectedJobExtent.id,
        company_id: selectedCompany.id,
        job_area: selectedArea.value,
        minimum_salary: salaryMinimum,
        maximum_salary: salaryMaximum,
        discrete_company: discreteCompany,
        discrete_salary: discreteSalary,
        employment_type: employmentType,
        job_city: jobCity,
        external_id: jobExternalId,
        job_recruitment_target: jobRecruitmentTarget,
        open_salary_question: openSalaryQuestion,
        open_salary_value_by: openSalaryValueBy,
        coordinator_name:
          coordinatorName === ""
            ? localStorage.getItem("userDisplayName")
            : coordinatorName,
        job_time_limit: 72,
        job_requirements: jobReqs,
        job_status: "active",
        auto_distribution: autoDistribution,
      },
      content: jobDescription,
      status: "publish",
    };
    axios
      .post(`/wp-json/wp/v2/jobs/${jobId}`, jobData)
      .then((jobRes) => {
        return axios.post("/wp-json/api/v2/updateJobFilterQuestions", {
          jobId: parseInt(jobRes.data.id),
          experience: { experienceFilterQuestions },
          talents: { talentsFilterQuestions },
          licenses: { licensesFilterQuestions },
          academicDegree: { academicDegreeFilterQuestions },
          certificate: { certificateFilterQuestions },
          languages: { languagesFilterQuestions },
          dynamics: { dynamicFilterQuestions },
        });
      })
      .then((res) => {
        props.addedSuccessfully(jobId);
      })
      .catch((err) => {
        setError(err.response);
      });
  };

  const handleAddFQ = (fqValue, type) => {
    //get the current type, and detect what FQ to add
    switch (type) {
      case AI_EXPERIENCES:
        setExperienceFilterQuestions(fqValue);
        break;
      case AI_SKILLS:
        setTalentsFilterQuestions(fqValue);
        break;
      case AI_LICENSES:
        setLicensesFilterQuestions(fqValue);
        break;
      case AI_ACADEMIC_DGREE:
        setAcademicDegreeFilterQuestions(fqValue);
        break;
      case AI_CERTIFICATES:
        setCertificateFilterQuestions(fqValue);
        break;
      case AI_LANGUAGES:
        setLanguagesFilterQuestions(fqValue);
        break;
      case AI_DYNAMICS:
        setDynamicsFilterQuestions(fqValue);
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    if (props.editMode > 0) {
      setIsEditMode(true);
      setJobId(props.editMode);

      axios
        .get(`/wp-json/api/v2/job/${props.editMode}`)
        .then((jobRes) => {
          setJobId(jobRes.data.id);
          setOwnerId(parseInt(jobRes.data.author));
          setJobTitle(jobRes.data.title);
          setJobDescription(jobRes.data.description);
          setSelectedJobExtent(jobRes.data.job_extent);
          setSelectedCompany(jobRes.data.company);
          setSelectedArea(jobRes.data.job_area);
          setSalaryMinimum(parseInt(jobRes.data.minimum_salary));
          setSalaryMaximum(parseInt(jobRes.data.maximum_salary));
          setDiscreteCompany(jobRes.data.discrete_company);
          setDiscreteSalary(jobRes.data.discrete_salary);
          setJobExternalId(jobRes.data.external_id);
          setSelectedProfessions(jobRes.data.professions);
          setEmploymentType(jobRes.data.employment_type);
          setJobsReqs(jobRes.data.job_requirements);
          setJobCity(jobRes.data.city);
          setCoordinatorName(jobRes.data.coordinator_name);
          setOpenSalaryQuestion(jobRes.data.open_salary_question);
          setAutoDistribution(jobRes.data.auto_distribution);
          setJobRecruitmentTarget(parseInt(jobRes.data.job_recruitment_target));
          setIsPublished(
            jobRes.data.published &&
              jobRes.data.published !== null &&
              jobRes.data.published !== ""
              ? true
              : false
          );
          setOpenSalaryValueBy(
            jobRes.data.open_salary_question
              ? jobRes.data.open_salary_value_by
              : "month"
          );
          const rawFilterQuestions = jobRes.data.filter_questions;
          const rawExperienceFQ = rawFilterQuestions.filter(
            (fqItem) => fqItem.fq_type === "experience"
          );
          const rawAcademicFQ = rawFilterQuestions.filter(
            (fqItem) => fqItem.fq_type === "academicDegree"
          );
          const rawLicensesFQ = rawFilterQuestions.filter(
            (fqItem) => fqItem.fq_type === "license"
          );
          const rawTalentsFQ = rawFilterQuestions.filter(
            (fqItem) => fqItem.fq_type === "talents"
          );
          const rawCertificatesFQ = rawFilterQuestions.filter(
            (fqItem) => fqItem.fq_type === "certificate"
          );
          const rawLanguagesFQ = rawFilterQuestions.filter(
            (fqItem) => fqItem.fq_type === "languages"
          );
          const rawDynamicFQ = jobRes.data.dynamic_filter_questions;
          setDynamicsFilterQuestions(rebuildDynamicsFQObject(rawDynamicFQ));
          setExperienceFilterQuestions(
            rebuildExperienceFQObject(rawExperienceFQ)
          );
          setLicensesFilterQuestions(rebuildLicensesFQObject(rawLicensesFQ));
          setTalentsFilterQuestions(rebuildTalentsFQObject(rawTalentsFQ));
          setAcademicDegreeFilterQuestions(
            rawAcademicFQ && rawAcademicFQ.length
              ? rebuildAcademicDegreeFQObject(rawAcademicFQ)
              : []
          );
          setCertificateFilterQuestions(
            rawCertificatesFQ && rawCertificatesFQ.length
              ? rebuildCertificateFQObject(rawCertificatesFQ)
              : []
          );
          setLanguagesFilterQuestions(rebuildLanguagesFQObject(rawLanguagesFQ));
        })
        .catch((err) => {
          setError(err.response);
        });
    }

    // in case of edit mode - get the data from the server:
  }, [props.editMode]);

  const verifyStepCompletion = (step) => {
    if (step === 1) {
      return (
        selectedCompany &&
        Object.keys(selectedCompany).length > 0 &&
        jobTitle.length > 2 &&
        jobDescription.length &&
        2 &&
        jobReqs.length > 2
      );
    }
    if (step === 2) {
      return (
        coordinatorName !== "" &&
        selectedProfessions.length > 0 &&
        selectedJobExtent &&
        Object.keys(selectedJobExtent).length > 0 &&
        selectedArea &&
        Object.keys(selectedArea).length > 0 &&
        jobCity !== ""
      );
    }
    return false;
  };

  const defaultProps = {
    options: React.useContext(ConfigurationListsContext).customersList,
    getOptionLabel: (cust) => cust.name,
  };

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <Box
            display="flex"
            flexDirection="column"
            maxWidth={200}
            my={"100px"}
            mx={"auto"}
            className={classes.addJobProgressMenu}
          >
            <Button
              color="primary"
              startIcon={<SaveRoundedIcon />}
              className={classes.ButtonRight}
            >
              Save as draft
            </Button>
            <Typography variant="h5" color="textPrimary">
              New Job
            </Typography>
            <CustomIcon
              step={"01"}
              label={"Job Description"}
              isActive={wizardStep === 1}
              stepClick={() => setWizardStep(1)}
              completed={verifyStepCompletion(1)}
            />
            <CustomIcon
              step={"02"}
              label={"Job Details"}
              isActive={wizardStep === 2}
              stepClick={() => setWizardStep(2)}
              completed={verifyStepCompletion(2)}
            />
            <CustomIcon
              step={"03"}
              label={"Filter Questions"}
              isActive={wizardStep === 3}
              stepClick={() => setWizardStep(3)}
              completed={verifyStepCompletion(3)}
            />
          </Box>
        </Grid>
        <ConfigurationListsContext.Consumer>
          {(context) => (
            <Grid item xs={10}>
              <Paper className={classes.paper}>
                <Grid container spacing={2} className={classes.gridSpace}>
                  <Grid item xs={1}></Grid>
                  {/* /***** THIS SECTION IS DEPEND ON WIZARD STEP */}
                  <Grid item xs={10}>
                    <Grid container spacing={2}>
                      {wizardStep === 1 && (
                        <React.Fragment>
                          <Grid item xs={12}>
                            <Box my={theme.spacing(4)}>
                              <Typography variant="h4" color="textPrimary">
                                {isEditMode ? "Update job" : "Add New Job"}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Autocomplete
                              {...defaultProps}
                              id="disable-close-on-select"
                              style={{ flex: 1 }}
                              onChange={(e, value) => {
                                setSelectedCompany(value);
                              }}
                              value={
                                selectedCompany &&
                                Object.keys(selectedCompany).length
                                  ? context.customersList.filter(
                                      (item) => item.id === selectedCompany.id
                                    )[0]
                                  : null
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  margin="normal"
                                  value={selectedCompany}
                                  style={{ marginTop: 8 }}
                                  label="Company Name"
                                  variant="filled"
                                />
                              )}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <FormControlLabel
                              label="Confidential Company"
                              control={
                                <Switch
                                  checked={discreteCompany}
                                  color="primary"
                                  onChange={() =>
                                    setDiscreteCompany(!discreteCompany)
                                  }
                                  name="DiscreteCompany"
                                />
                              }
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl component="fieldset">
                              <FormLabel>Employment Type</FormLabel>
                              <RadioGroup
                                aria-label="employmentType"
                                name="employmentType"
                                value={employmentType}
                                onChange={(event) =>
                                  setEmploymentType(event.target.value)
                                }
                                row
                              >
                                <FormControlLabel
                                  value="recruitment"
                                  control={<Radio color="primary" />}
                                  label="Recruitment"
                                />
                                <FormControlLabel
                                  value="employment"
                                  control={<Radio color="primary" />}
                                  label="Employment"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              required
                              label="Job Title"
                              id="jobTitle"
                              margin="normal"
                              variant="filled"
                              fullWidth
                              value={jobTitle}
                              onChange={(e) => setJobTitle(e.target.value)}
                              className={classes.textField}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              id="job-description"
                              label="Job Description"
                              InputLabelProps={{
                                shrink: jobDescription !== "",
                              }}
                              multiline
                              onChange={handleJobsDescriptionChange}
                              fullWidth
                              rows={5}
                              defaultValue={jobDescription}
                              variant="filled"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              id="job-requirements"
                              label="Job Requirements"
                              multiline
                              fullWidth
                              onChange={handleJobsReqsChange}
                              rows={5}
                              InputLabelProps={{
                                shrink: jobReqs !== "",
                              }}
                              defaultValue={jobReqs}
                              variant="filled"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <FormControlLabel
                              label="Automatic Distribution"
                              control={
                                <Switch
                                  checked={autoDistribution}
                                  color="primary"
                                  onChange={() =>
                                    setAutoDistribution(!autoDistribution)
                                  }
                                  name="autDistribution"
                                />
                              }
                            />
                          </Grid>
                        </React.Fragment>
                      )}
                      {wizardStep === 2 && (
                        <React.Fragment>
                          <Grid item xs={12}>
                            <Box my={theme.spacing(4)}>
                              <Typography variant="h4" color="textPrimary">
                                Job Details
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <ConfigurationListsContext.Consumer>
                              {(context) => (
                                <CoordinatorsDropdown
                                  coordsList={context.users}
                                  selectedAuthor={
                                    ownerId > 0
                                      ? ownerId
                                      : parseInt(localStorage.getItem("userId"))
                                  }
                                  onSelect={(value) => setOwnerId(value.id)}
                                  label="Recruiter Owner"
                                  variant="filled"
                                />
                              )}
                            </ConfigurationListsContext.Consumer>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              required
                              label="Recruiter publish name"
                              id="displayName"
                              margin="none"
                              fullWidth
                              variant="filled"
                              value={coordinatorName}
                              onChange={(e) =>
                                setCoordinatorName(e.target.value)
                              }
                              className={classes.textField}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Autocomplete
                              multiple
                              id="tags-outlined"
                              limitTags={2}
                              options={
                                context.professionsList
                                  ? context.professionsList.sort(
                                      (a, b) => a.parent_id > b.parent_id
                                    )
                                  : null
                              }
                              //groupBy={(options) => options.parent_id}
                              //options={context.professionsList}
                              getOptionLabel={(prof) => prof.name}
                              onChange={(e, value) =>
                                setSelectedProfessions(value)
                              }
                              //value={Object.values(selectedProfessions)}
                              value={selectedProfessions.map(
                                (sp) =>
                                  context.professionsList.filter(
                                    (item) => item.id === sp.id
                                  )[0]
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="filled"
                                  label="Select Relevant Professions"
                                  placeholder="Professions"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Autocomplete
                              options={context.jobExtentList}
                              getOptionLabel={(je) => je.value}
                              id="jobExtent"
                              onChange={(e, value) =>
                                setSelectedJobExtent(value)
                              }
                              value={
                                selectedJobExtent !== null &&
                                Object.keys(selectedJobExtent).length
                                  ? Object.values(
                                      context.jobExtentList.filter(
                                        (item) =>
                                          item.id === selectedJobExtent.id
                                      )
                                    )[0]
                                  : null
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  margin="none"
                                  value={selectedJobExtent}
                                  label="Job Type"
                                  required
                                  variant="filled"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Autocomplete
                              options={context.areasList}
                              getOptionLabel={(area) => area.value}
                              id="area"
                              onChange={(e, value) => {
                                setSelectedArea(value);
                              }}
                              value={
                                selectedArea !== null &&
                                Object.keys(selectedArea).length
                                  ? context.areasList.find(
                                      (item) => item.id === selectedArea.id
                                    )
                                  : null
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  margin="normal"
                                  required
                                  value={
                                    selectedArea !== null
                                      ? Object.values(selectedArea)
                                      : null
                                  }
                                  label="Job Area"
                                  variant="filled"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              required
                              label="City"
                              id="jobCity"
                              margin="normal"
                              fullWidth
                              variant="filled"
                              value={jobCity ? jobCity : ""}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <LocationCityRoundedIcon />
                                  </InputAdornment>
                                ),
                              }}
                              onChange={(e) => setJobCity(e.target.value)}
                              className={classes.textField}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              required
                              label="External ID"
                              id="externalId"
                              margin="none"
                              variant="filled"
                              value={jobExternalId}
                              fullWidth
                              onChange={(e) => setJobExternalId(e.target.value)}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl variant="filled" fullWidth>
                              <InputLabel id="recruitmentTarget">
                                Recruitment Targets
                              </InputLabel>

                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={jobRecruitmentTarget}
                                onChange={(event) =>
                                  setJobRecruitmentTarget(event.target.value)
                                }
                                label="Recruitments required"
                                labelWidth={200}
                              >
                                <MenuItem value={0}>
                                  <em>None</em>
                                </MenuItem>
                                {targetMenuItems()}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12}>
                            <Box display="flex" alignItems="center">
                              <FormLabel
                                component="legend"
                                style={{ marginRight: theme.spacing(2) }}
                              >
                                Salary Period Unit
                              </FormLabel>
                              <RadioGroup
                                aria-label="openSalaryBy"
                                name="openSalaryBy"
                                value={openSalaryValueBy}
                                onChange={handleOpenSalaryValueChange}
                                style={{ flexDirection: "row" }}
                              >
                                <FormControlLabel
                                  value="month"
                                  control={<Radio color="primary" />}
                                  label="Monthly Rate"
                                />
                                <FormControlLabel
                                  value="hour"
                                  control={<Radio color="primary" />}
                                  label="Hourly Rate"
                                />
                              </RadioGroup>
                            </Box>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl
                              className={classes.formControl}
                              variant="outlined"
                              error={salaryMinimum > salaryMaximum}
                              fullWidth
                            >
                              <InputLabel htmlFor="minimumAmount">
                                Salary from
                              </InputLabel>
                              <OutlinedInput
                                id="minimumAmount"
                                value={salaryMinimum}
                                type="number"
                                inputProps={{ min: 0, step: 5 }}
                                onChange={handleMinimumSalaryChange}
                                startAdornment={
                                  <InputAdornment position="start">
                                    &euro;
                                  </InputAdornment>
                                }
                                labelWidth={80}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl
                              className={classes.formControl}
                              variant="outlined"
                              fullWidth
                            >
                              <InputLabel htmlFor="maximumAmount">
                                Max Salary
                              </InputLabel>
                              <OutlinedInput
                                id="maximumAmount"
                                value={salaryMaximum}
                                type="number"
                                inputProps={{ min: 0, step: 5 }}
                                onChange={handleMaximumSalaryChange}
                                startAdornment={
                                  <InputAdornment position="start">
                                    &euro;
                                  </InputAdornment>
                                }
                                labelWidth={90}
                              />
                            </FormControl>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <FormControlLabel
                              label="Confidential Salary"
                              control={
                                <Switch
                                  checked={discreteSalary}
                                  color="primary"
                                  onChange={() =>
                                    setDiscreteSalary(!discreteSalary)
                                  }
                                  name="DiscreteSalary"
                                />
                              }
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={openSalaryQuestion}
                                  color="primary"
                                  onChange={(e) =>
                                    setOpenSalaryQuestion(e.target.checked)
                                  }
                                  name="openSalaryQuestion"
                                />
                              }
                              label="Show open salary question"
                            />
                          </Grid>
                        </React.Fragment>
                      )}
                      {wizardStep === 3 && (
                        <React.Fragment>
                          <Grid item xs={12}>
                            <Box my={theme.spacing(4)}>
                              <Typography
                                variant="h4"
                                color="textPrimary"
                                paragraph
                              >
                                Add Filter Questions
                              </Typography>
                              <Typography variant="caption" color="textPrimary">
                                Filter Questions are optional.
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <FQDropdownBox
                              fqName="Experience"
                              fqValue={experienceFilterQuestions}
                              type={AI_EXPERIENCES}
                              addFQ={handleAddFQ}
                              locked={!isEditMode && isPublished}
                            />
                            <FQDropdownBox
                              fqName="Skills"
                              fqValue={talentsFilterQuestions}
                              type={AI_SKILLS}
                              addFQ={handleAddFQ}
                              locked={!isEditMode && isPublished}
                            />
                            <FQDropdownBox
                              fqName="Licenses"
                              fqValue={licensesFilterQuestions}
                              type={AI_LICENSES}
                              addFQ={handleAddFQ}
                              locked={!isEditMode && isPublished}
                            />
                            <FQDropdownBox
                              fqName="Languages"
                              fqValue={languagesFilterQuestions}
                              type={AI_LANGUAGES}
                              addFQ={handleAddFQ}
                              locked={!isEditMode && isPublished}
                            />
                            <FQDropdownBox
                              fqName="Academic Degrees"
                              fqValue={academicDegreeFilterQuestions}
                              type={AI_ACADEMIC_DGREE}
                              addFQ={handleAddFQ}
                              locked={!isEditMode && isPublished}
                            />
                            <FQDropdownBox
                              fqName="Certifications"
                              fqValue={certificateFilterQuestions}
                              type={AI_CERTIFICATES}
                              addFQ={handleAddFQ}
                              locked={!isEditMode && isPublished}
                            />
                            <FQDropdownBox
                              fqName="Dynamic Questions"
                              fqValue={dynamicFilterQuestions}
                              type={AI_DYNAMICS}
                              addFQ={handleAddFQ}
                              locked={!isEditMode && isPublished}
                            />
                          </Grid>
                        </React.Fragment>
                      )}
                    </Grid>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      my={theme.spacing(4)}
                    >
                      <div>
                        <Button
                          color="primary"
                          startIcon={<NavigateBeforeRoundedIcon />}
                          variant="outlined"
                          disabled={wizardStep === 1 ? true : false}
                          style={{
                            cursor: wizardStep === 1 ? "default" : "pointer",
                          }}
                          onClick={() =>
                            setWizardStep((prev) => (prev > 1 ? prev - 1 : 1))
                          }
                        >
                          Back
                        </Button>
                        <Button
                          variant="outlined"
                          className={classes.cancel}
                          onClick={props.cancelNewJob}
                        >
                          Cancel
                        </Button>
                      </div>
                      {wizardStep === 3 ? (
                        <ErrorBoundary>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            endIcon={<Icon>add</Icon>}
                            disabled={
                              jobTitle === "" ||
                              salaryMinimum > salaryMaximum ||
                              coordinatorName === "" ||
                              Object.keys(selectedCompany).length === 0 ||
                              jobReqs === "" ||
                              jobDescription === ""
                            }
                            onClick={isEditMode ? updateJob : postNewJob}
                          >
                            {isEditMode ? "Update Job" : "Add Job"}
                          </Button>
                        </ErrorBoundary>
                      ) : (
                        <Button
                          color="primary"
                          endIcon={<NavigateNextRoundedIcon />}
                          variant="contained"
                          onClick={() =>
                            setWizardStep((prev) => (prev < 3 ? prev + 1 : 3))
                          }
                        >
                          Continue
                        </Button>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
        </ConfigurationListsContext.Consumer>
      </Grid>
      {error &&
        error.response(
          <AxiosErrorHandling
            title="Error in job creation"
            error={error.response}
          />
        )}
    </React.Fragment>
  );
};
export default withRouter(AddNewJob);
